import dayjs from 'dayjs';
import * as yup from 'yup';

declare module 'yup' {
  interface DateSchema {
    italianFormat(): DateSchema;
  }
}

const invalidDate = new Date('');

yup.addMethod(yup.date, 'italianFormat', function () {
  return this.transform((value: dayjs.Dayjs, originalValue) => {
    const parsed = dayjs(originalValue, [
      'DD-MM-YYYY',
      'DD/MM/YYYY',
      'MMM DD YYYY hh:mmA',
      'YYYY-MM-DD',
      'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
    ]);

    return parsed.isValid() ? parsed.toDate() : invalidDate;
  });
});
